import React from 'react'
import Sidebar from '../../../Components/Sidebar/Sidebar';
import { digitizerSideBarItems } from './Routes'

const Navbar = () => {
    return <Sidebar sideBarItems={digitizerSideBarItems} />
}

export default Navbar;